import { useDispatch, useSelector } from 'react-redux'
import * as actions from '../../../store/slices'
import { supportProgramTypes } from '../../../constants/support-programs'
import constants from '../../../constants'
import { useEffect } from 'react'

const useFetchDocuments = () => {
  const dispatch = useDispatch()
  const { patientDetails } = useSelector((state) => state.auth)
  const supportProgram = supportProgramTypes[constants.CARE_PROGRAM_TYPE.ANAYA]
  const { ftuDocumentsWithoutVisit: documents } = useSelector(
    (state) => state.records,
  )
  useEffect(() => {
    fetchDocuments()
  }, [])

  const fetchDocuments = () => {
    const payload = {
      patient_id: patientDetails?.data?.patient_id,
      report_type: supportProgram.upload_report_type,
    }
    new Promise((resolve, reject) => {
      dispatch(
        actions.fetchLiverFTUDocumentsWithoutVisitRequest({
          payload,
          resolve,
          reject,
        }),
      )
    })
  }

  return {
    fetchDocuments,
    documents,
  }
}
export default useFetchDocuments
